@if (data(); as msg) {
    <category-item 
        class="d-inline-block me-2"
        [category]="msg.category"  />
    <span>not found.</span>
}
 